import { render, staticRenderFns } from "./EnfermeriaTransf.vue?vue&type=template&id=0d6cbcd2&"
import script from "./EnfermeriaTransf.vue?vue&type=script&lang=js&"
export * from "./EnfermeriaTransf.vue?vue&type=script&lang=js&"
import style0 from "./EnfermeriaTransf.vue?vue&type=style&index=0&id=0d6cbcd2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports